import { RouteObject } from "react-router-dom";
import Landing from "./components/landing/landing";
export interface DashboardRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: DashboardRoute[];
}
export const dashboardRoutes: DashboardRoute[] = [
  {
    path: "/bx/dashboard",
    element: <Landing />,
  },
];
